import { useParams } from '@suntex.core/nav'
import { SchoolId } from '@suntex.fim/api-client'
import {
  SchoolProvider,
  useSchool,
  useSchoolMovePlayers
} from '@suntex.fim/school'

import MovePlayersBoard from './MovePlayersBoard'

function SchoolMovePlayersInner() {
  const { schoolId } = useSchool()
  const { teams, isLoading, reload } = useSchoolMovePlayers()
  if (schoolId === null) {
    return null
  }
  return (
    <MovePlayersBoard
      schoolId={schoolId}
      teams={teams}
      isLoading={isLoading}
      reload={reload}
    />
  )
}

function SchoolMovePlayers() {
  const { schoolId: schoolIdParam } = useParams<{ schoolId: string }>()
  const parsed = Number(schoolIdParam)
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return null
  }
  const schoolId = parsed as SchoolId
  return (
    <SchoolProvider key={schoolId} schoolId={schoolId}>
      <SchoolMovePlayersInner />
    </SchoolProvider>
  )
}

export default SchoolMovePlayers
